import React, { memo } from 'react';
import { Route, Switch } from 'react-router-dom';
import OrderCreator from 'containers/Orders/OrderCreator/OrderCreator';
import OrderDetails from 'containers/Orders/OrderDetails/OrderDetails';
import OrdersDashboard from 'containers/Orders/OrdersDashboard';
function Orders({ url }) {
    return (React.createElement(Switch, null,
        React.createElement(Route, { exact: true, path: `${url}` },
            React.createElement(OrdersDashboard, null)),
        React.createElement(Route, { path: `${url}/creator/:orderId` },
            React.createElement(React.Fragment, null,
                React.createElement(OrdersDashboard, null),
                React.createElement(OrderCreator, null))),
        React.createElement(Route, { path: `${url}/:orderId/:tab?` },
            React.createElement(OrderDetails, null))));
}
export default memo(Orders);
